import {toastr} from 'react-redux-toastr';
import {getAdminShoppingCart } from '../actions';
import {
  navigateTo,
  postJsonAsync
} from 'shared/actions';
import {setErrorList} from 'shared/error/actionTypes';
import {
  loadReservationReview,
  updateSquadQuantity,
  updateVirtualEventQuantity,
  updateCartTotal,
  displayClearCartConfirmation,
  processingStarted,
  processingFinished
} from './actionTypes';
import {setReturningToCalendar} from '../actionTypes';
import { displayErrorList } from '../../shared/error/errorManager';

export const handleReserveClick = () => (dispatch, getState) => {
  const state = getState();
  const captain = {...state.form.captainInformationForm.values};
  const coordinator = {...state.form.coordintorInformationForm.values};
  const entries = state.admin.review.cart.squads;
  const virtualEntries = state.admin.review.cart.virtualEvents;
  const tournamentId = state.admin.base.tournament.id;
  const payload = {tournamentId, entries, virtualEntries, captain, coordinator};

  dispatch(processingStarted());
  dispatch(postJsonAsync(`admin/tournament/${tournamentId}/reservation`, payload))
  .then(response => {
    const errorMessages = response.messages;
    if (errorMessages && errorMessages.length > 0)
    {
      dispatch(displayErrorList(errorMessages));
      dispatch(processingFinished());
    }
    else
    {
      toastr.success('Saved!', 'Registration saved successfully.');
      delete localStorage.adminCart;
      dispatch(processingFinished());
      dispatch(navigateTo(`admin/captain/${response.captainId}`));
    }
  })
  .catch(() => {
    dispatch(processingFinished());
  });
};

export const handleContinueReservingClick = () => dispatch =>{
  dispatch(setReturningToCalendar());
  dispatch(navigateTo(`admin/squads`));
};

export const cancelReservation = () => dispatch => {
  delete localStorage.adminCart;
  dispatch(displayClearCartConfirmation(false));
  dispatch(navigateTo(`admin/squads`));
};

export const removeSquadItemFromAdminCart = id => dispatch => {
  let adminCart = getAdminShoppingCart();

  adminCart.squads = adminCart.squads.filter(item => item.id != id);
  localStorage.adminCart = JSON.stringify(adminCart);
  dispatch(setErrorList([]));
  dispatch(loadReservationReview(adminCart));
};

export const removeVirtualEventFromAdminCart = id => dispatch => {
  let adminCart = getAdminShoppingCart();

  adminCart.virtualEvents = adminCart.virtualEvents.filter(item => item.id != id);
  localStorage.adminCart = JSON.stringify(adminCart);
  dispatch(setErrorList([]));
  dispatch(loadReservationReview(getAdminShoppingCart()));
};

export const handleOnSquadQuantityChange = data => dispatch => {
  dispatch(setErrorList([]));
  dispatch(updateSquadQuantity(data));
  dispatch(updateCartTotal());

  let shoppingCart = getAdminShoppingCart(),
    item = shoppingCart.squads.find(x => x.id === data.squadId) || null;

  if (item === null) return;
  item.quantity = Number(data.inputValue);
  sessionStorage.adminCart = JSON.stringify(shoppingCart);
};

export const handleOnVirtualEventQuantityChange = data => dispatch => {
  dispatch(updateVirtualEventQuantity(data));
  dispatch(updateCartTotal());

  let shoppingCart = getAdminShoppingCart(),
    item = shoppingCart.virtualEvents.find(x => x.id === data.virtualEventId) || null;

  if (item === null) return;
  item.quantity = Number(data.inputValue);
  sessionStorage.adminCart = JSON.stringify(shoppingCart);
};



// WEBPACK FOOTER //
// ./src/features/admin/review/actions.js